import * as React from 'react'

const CFXUSD = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <path d='M9 26.7085V19.7085L24 5.7085L39 19.7085V26.7085L24 11.7085L9 26.7085Z' fill='black' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24 19.6646L12.6863 30.978L24 42.2915L35.3137 30.978L31.7782 27.4424L24 35.2207L19.7574 30.978L27.5355 23.1997L24 19.6646Z'
      fill='black'
    />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#CAD0E1' />
  </svg>
)

export default CFXUSD
